import IntegrationType from 'crono-fe-common/types/enums/integrationType';
import { getError } from 'crono-fe-common/utils';
import { isCronoError } from 'utils/validationUtils';

const getErrorMessage = (error: unknown) => {
  if (isCronoError(error)) return getError(error);
  if (error instanceof Error && error.message) return error.message;
  return 'Unknown error';
};

/**
 * Persists why a CRM connection failed, so the Connect page can surface it once
 * the callback route has redirected there.
 */
const storeOnboardingError = (error: unknown, crm: IntegrationType) => {
  const localStorageName = process.env.VITE_APP_ERROR_ONBOARDING_CALL;
  if (!localStorageName) return;

  localStorage.setItem(
    localStorageName,
    JSON.stringify({ error: getErrorMessage(error), crm }),
  );
};

export default storeOnboardingError;
